/*! impulsa3-pdp.js — comportamiento de los componentes propios de la PDP v2.

    Mismo patrón que el theme: custom element + Motion.inView (la librería Motion ya
    viene cargada por theme.js) y respeto de theme.config.motionReduced, como hacen
    AnimateElement y AnimatePicture. */

/* Marca el elemento con .is-visible cuando entra en el viewport, una sola vez.
   Las animaciones viven en el CSS (impulsa3-pdp.css), colgando de esa clase. */
class Impulsa3InView extends HTMLElement {
  connectedCallback() {
    if (this.classList.contains('is-visible')) return;

    // Sin Motion, o con movimiento reducido: al estado final directamente.
    // El CSS desactiva la transición bajo prefers-reduced-motion, así que no anima.
    if (typeof Motion === 'undefined' || window.theme?.config?.motionReduced) {
      this.classList.add('is-visible');
      return;
    }

    Motion.inView(
      this,
      () => {
        this.classList.add('is-visible');
      },
      { amount: 0.3 }
    );
  }
}

if (!customElements.get('impulsa3-in-view')) {
  customElements.define('impulsa3-in-view', Impulsa3InView);
}
